
    var riot = require('riot')
    //src: starling/src/tags/external-link-popover.html
riot.tag2('external-link-popover',
  '<div if="{linkIsEditable}" class="external-link-container external-link-container--editable"> <input show="{isEditingLink}" ref="field" class="external-link-container_field" type="text" riot-value="{href}" onblur="{onFieldBlur}" onkeydown="{onFieldKeyDown}" placeholder="Enter link url"> <div show="{!isEditingLink}" class="external-link-container_edit-bar"> <a if="{!isInternal}" class="external-link-container_link" href="{href}" target="_blank">{href}</a> <a if="{isInternal}" class="external-link-container_link" href="{href}" target="_blank" onclick="{panToLink}">{href}</a> <button if="{linkIsEditable}" class="Button Button--Icon Button--Plain Button--Small" data-tip="Edit link" data-tip-align="top" onclick="{startEditing}" data-no-selection-change> <svg data-no-selection-change class="Button__Icon"> <use xlink:href="#edit-icon"></use> </svg> </button> <button if="{isLinkPreviewable}" class="Button Button--Icon Button--Plain Button--Small" data-tip="{linkPreviewIsHidden() ? \'Add preview to card\' : \'Delete preview from card\'}" data-tip-align="top" onclick="{toggleLinkPreviewHidden}" data-no-selection-change> <svg class="Button__Icon"> <use xlink:href="#{linkPreviewIsHidden() ? \'show-link-preview\' : \'hide-link-preview\'}"></use> </svg> </button> <button if="{!autoLinkified && linkIsEditable}" class="Button Button--Icon Button--Plain Button--Small" data-tip="Remove link" data-tip-align="top" onclick="{removeLink}" data-no-selection-change> <svg data-no-selection-change class="Button__Icon"> <use xlink:href="#delete-icon"></use> </svg> </button> </div> </div> <div if="{!linkIsEditable}"> <a if="{isInternal}" class="external-link-container" onclick="{panToLink}"> <span>{href}</span> </a> <div if="{!isInternal && isLinkPreviewable && nodeTag}" class="plectica-link-container"> <button class="link-preview-toggle" data-tip="{linkPreviewIsHidden() ? \'Add preview to card\' : \'Delete preview from card\'}" data-tip-align="top" onclick="{toggleLinkPreviewHidden}"> <svg class="link-preview-toggle_icon"> <use xlink:href="#{linkPreviewIsHidden() ? \'show-link-preview\' : \'hide-link-preview\'}"></use> </svg> </button> <a href="{href}" target="_blank" rel="noopener noreferrer" class="plectica-link_external" data-tip="Open link in new tab" data-tip-align="top"> <span class="plectica-link_external_url">{href}</span> <svg class="plectica-link_external_icon"> <use xlink:href="#open-in-new-icon"></use> </svg> </a> </div> <div if="{(!isInternal && !isLinkPreviewable) || (!isInternal && isLinkPreviewable && !nodeTag)}"> <a href="{href}" class="external-link-container" target="_blank" rel="noopener noreferrer" data-tip="Open link in new tab" data-tip-align="top"> <span>{href}</span> <svg class="plectica-link_external_icon"> <use xlink:href="#open-in-new-icon"></use> </svg> </a> </div> </div>',
  '',
  'class="{hidden ? \'hidden\' : \'active\'}" riot-style="top: {y}px; left: {x}px"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _sharedUtil = require('lib/shared-util');

var _sitePreviewUi = require('lib/site-preview-ui');

var _constants = require('lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;
var config = canvas.config,
    access = canvas.access;

this.hidden = true;
this.anchorTag = null;
this.linkIsEditable = false;
this.isEditingLink = false;

canvas.externalLinkPopover = this;

this.summon = function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      href = _ref.href,
      anchorTag = _ref.anchorTag,
      nodeTag = _ref.nodeTag,
      isEditing = _ref.isEditing,
      autoLinkified = _ref.autoLinkified,
      isNotEditable = _ref.isNotEditable,
      editableElement = _ref.editableElement,
      _ref$aIndex = _ref.aIndex,
      aIndex = _ref$aIndex === undefined ? null : _ref$aIndex;

  _this.aIndex = aIndex;
  _this.editableElement = editableElement;
  _this.isEditingLink = isEditing;
  _this.autoLinkified = Boolean(autoLinkified);
  _this.linkIsEditable = !Boolean(isNotEditable);

  if (isEditing) {
    _this.linkIsEditable = true;
  }

  if (anchorTag) {
    if (anchorTag.closest('.node_title[contenteditable], .node_summary[contenteditable]')) {
      if (window.getSelection().toString() && !isEditing) {
        canvas.textToolbar.toggle();
        return;
      }

      _this.linkIsEditable = true;
    }

    _this.anchorTag = anchorTag;

    var _anchorTag$getBoundin = anchorTag.getBoundingClientRect(),
        left = _anchorTag$getBoundin.left,
        top = _anchorTag$getBoundin.top;

    _this.lastPosition = { x: left, y: top };

    Object.assign(_this, {
      href: href,
      nodeTag: nodeTag || false,
      x: left - 10,
      y: top - 10,
      isInternal: (0, _sharedUtil.isUrlInternal)({
        config: config,
        access: access,
        url: href
      }),
      isLinkPreviewable: (0, _sharedUtil.isUrlPlecticaMap)({
        config: config,
        url: href
      }) && (0, _sharedUtil.isNotLinkToNodeOrRegion)({ href: href })
    });
  } else {
    _this.lastPosition = { x: x, y: y };

    _this.x = x;
    _this.y = y;
    _this.href = '';
  }

  _this.hidden = false;

  _this.update();
};

this.startEditing = function () {
  _this.isEditingLink = true;

  if (_this.aIndex !== null) {
    _this.anchorTag = _this.editableElement.querySelectorAll('a')[_this.aIndex];
  }
  _this.update();
};

this.saveLink = function (e) {
  var url = e.target.value;

  if (url !== _this.href) {
    _this.anchorTag = _this.editableElement.querySelectorAll('a')[_this.aIndex];
    canvas.textToolbar.linkChangeHandler(url, _this.anchorTag);
  }
};

this.removeLink = function () {
  if (_this.aIndex !== null) {
    _this.anchorTag = _this.editableElement.querySelectorAll('a')[_this.aIndex];
  }

  canvas.textToolbar.removeLink(_this.anchorTag);
  _this.hide();
};

this.onFieldBlur = function (e) {
  if (!_this.escapeKeyPressed) {
    _this.saveLink(e);
  }

  _this.escapeKeyPressed = false;
};

this.onFieldKeyDown = function (e) {
  if (e.keyCode === _constants.KEY_CODES.ENTER) {
    e.preventDefault();
    e.stopPropagation();
    _this.refs.field.blur(e);

    if (e.target.value) {
      if (_this.anchorTag) {
        _this.href = _this.anchorTag.getAttribute('href');
      } else {
        var selection = document.getSelection();
        var selectionLength = selection.toString().length;
        var range = selectionLength && selection.getRangeAt(0);

        var selectedNode = range.commonAncestorContainer;
        var selectedElement = selectedNode.nodeType == 1 ? selectedNode : selectedNode.parentElement;

        var anchorTag = selectedElement.closest('[contenteditable] a');
        var aIndex = Array.from(_this.editableElement.querySelectorAll('a')).findIndex(function (a) {
          return a === anchorTag;
        });

        _this.hide();
        _this.summon({
          editableElement: _this.editableElement,
          aIndex: aIndex,
          anchorTag: anchorTag,
          href: anchorTag.getAttribute('href'),
          isEditing: true,
          autoLinkified: anchorTag.classList.contains('linkified')
        });
      }

      _this.isEditingLink = false;
      _this.update();
    } else {
      _this.hide();
    }
  }

  if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
    e.preventDefault();
    e.stopPropagation();

    _this.isEditingLink = false;
    _this.escapeKeyPressed = true;

    if (!_this.anchorTag) {
      _this.hide();
    }

    _this.update();
  }
};

this.hide = function () {
  if (_this.refs.field) {
    _this.refs.field.blur();
  }
  _this.hidden = true;
  _this.linkIsEditable = false;
  _this.isEditingLink = false;
  _this.aIndex = null;

  if (_this.anchorTag) {
    _this.anchorTag = null;
  }

  _this.update();
};

this.panToLink = function (e) {
  e.preventDefault();

  var _ref2 = new URL(_this.href),
      searchParams = _ref2.searchParams;

  var nodes = searchParams.get('nodeid');
  var regions = searchParams.get('regionId');

  var nodeIds = nodes ? nodes.split(',') : [];
  var regionIds = regions ? regions.split(',') : [];

  var centeringNodes = _store_instance2.default.filterNodes(function (_ref3) {
    var id = _ref3.id;
    return nodeIds.includes(id);
  });
  var centeringRegions = regionIds.filter(function (id) {
    return _store_instance2.default.getRegion(id);
  }).map(function (id) {
    return { id: id };
  });

  if (centeringNodes.length || centeringRegions.length) {
    canvas.centerContent({
      nodes: centeringNodes,
      regions: centeringRegions
    }, { animate: true });

    canvas.setSelectedElements(centeringNodes.map(function (_ref4) {
      var id = _ref4.id;
      return canvas.nodeTags[id];
    }));
  }
};

this.linkPreviewIsHidden = function () {
  if (!_this.nodeTag) return true;

  return _sitePreviewUi.spUI.getLinkIsHidden({
    nodeId: _this.nodeTag.id,
    url: _this.href
  });
};

this.toggleLinkPreviewHidden = function (e) {
  e.stopPropagation();
  e.preventDefault();

  var newState = !_this.linkPreviewIsHidden();

  _sitePreviewUi.spUI.setLinkIsHidden({
    nodeTag: _this.nodeTag,
    url: _this.href,
    isHidden: newState
  });

  _this.update();
};

this.on('mount', function () {
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.on('updated', function () {
  if (_this.isEditingLink) {
    _this.refs.field.focus();
  }
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('external-link-popover')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/external-link-popover.html
// module id = 591
// module chunks = 0